import { useEffect, useRef, useState } from 'react';
import BasicVideo from './video/BasicVideo';
import { Button } from '@components/amc/Button';
import { Rnd } from 'react-rnd';
import _ from 'lodash';
import { MediaContentMediaType } from '@apis/common/response';
import ReactDOM from 'react-dom';
import { IconChevronLeft, IconChevronRight, IconX } from '@tabler/icons-react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const RndMediaWindow = ({
  title = '',
  medias,
  initialMediaIndex = 0,
  size = null,
  position = null,
  onClose,
  onDragStop,
  onResizeStop,
  videoRef = null
}) => {
  const dragRef = useRef(null);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(initialMediaIndex);
  const currentMedia = medias[currentMediaIndex];
  useEffect(() => {
    setCurrentMediaIndex(initialMediaIndex);
  }, [initialMediaIndex]);
  const defaultModalWindowSize = {
    width: 640,
    height: 560
  };
  const modalWindowSize = size ? size : defaultModalWindowSize;
  const defaultPositionX = (window.innerWidth - modalWindowSize.width) / 2;
  const defaultPositionY = (window.innerHeight - modalWindowSize.height) / 2;
  const positionX = !_.isNil(position?.xPercent) && !_.isNaN(position?.xPercent) ? position?.xPercent * window.innerWidth / 100 : null;
  const positionY = !_.isNil(position?.yPercent) && !_.isNaN(position?.yPercent) ? position?.yPercent * window.innerHeight / 100 : null;
  const hasMultipleMedia = medias.length > 1;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(Rnd, {
      className: "!fixed z-[999999] top-0 left-1/2 bg-my-gray-95 rounded-xl border-my-gray-70 border border-solid",
      style: {
        boxShadow: '0px 8px 24px 0px rgba(23, 32, 42, 0.16)'
      },
      onDragStop: (e, data) => {
        if (onDragStop) onDragStop({
          xPercent: data.x * 100 / window.innerWidth,
          yPercent: data.y * 100 / window.innerHeight
        });
      },
      default: {
        x: !_.isNil(positionX) ? positionX : defaultPositionX,
        y: !_.isNil(positionY) ? positionY : defaultPositionY,
        width: modalWindowSize.width,
        height: modalWindowSize.height
      },
      cancel: ".video-container, .close-btn",
      minWidth: '480px',
      minHeight: '320px',
      maxWidth: '1080px',
      maxHeight: '810px',
      onResizeStop: (e, direction, ref, delta, position) => {
        if (onResizeStop) onResizeStop({
          width: ref.clientWidth,
          height: ref.clientHeight
        }, {
          xPercent: position.x * 100 / window.innerWidth,
          yPercent: position.y * 100 / window.innerHeight
        });
      },
      bounds: '#__next',
      children: /*#__PURE__*/_jsx("div", {
        ref: dragRef,
        className: "w-full h-full",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col w-full h-full",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex justify-between h-10 px-4 py-2",
            children: [/*#__PURE__*/_jsx("span", {
              className: "text-title-sm-700 text-my-gray-10",
              children: title
            }), /*#__PURE__*/_jsx(Button, {
              icon: /*#__PURE__*/_jsx(IconX, {}),
              className: "close-btn",
              size: "Small",
              variant: "Ghost",
              onClick: onClose
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex-1 px-1 pb-1 min-h-[1px]",
            style: {
              height: 'calc(100% - 2.5rem)'
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "flex items-center justify-center w-full h-full overflow-hidden rounded-lg cursor-default video-container bg-my-gray-100",
              children: [hasMultipleMedia && /*#__PURE__*/_jsx(Button, {
                icon: /*#__PURE__*/_jsx(IconChevronLeft, {
                  color: currentMediaIndex === 0 ? 'var(--gray-60)' : 'var(--gray-10)'
                }),
                size: "Medium",
                variant: "Ghost",
                onClick: () => setCurrentMediaIndex(currentMediaIndex - 1),
                disabled: currentMediaIndex === 0,
                className: "mx-2"
              }), /*#__PURE__*/_jsx("div", {
                className: "flex items-center justify-center",
                style: {
                  width: hasMultipleMedia ? 'calc(100% - 48px)' : '100%',
                  height: '100%'
                },
                children: currentMedia.type === MediaContentMediaType.VIDEO ? /*#__PURE__*/_jsx(BasicVideo, {
                  lectureUrl: currentMedia.url,
                  ref: videoRef
                }) : /*#__PURE__*/_jsx("img", {
                  src: currentMedia.url,
                  className: "max-h-full",
                  alt: ""
                })
              }), hasMultipleMedia && /*#__PURE__*/_jsx(Button, {
                icon: /*#__PURE__*/_jsx(IconChevronRight, {
                  color: currentMediaIndex === medias.length - 1 ? 'var(--gray-60)' : 'var(--gray-10)'
                }),
                size: "Medium",
                variant: "Ghost",
                onClick: () => setCurrentMediaIndex(currentMediaIndex + 1),
                disabled: currentMediaIndex === medias.length - 1,
                className: "mx-2"
              })]
            })
          })]
        })
      })
    }), document.getElementById('__next'))
  });
};
export default RndMediaWindow;